import styled from "@emotion/styled";
import { Link } from "react-router-dom";

export const NavButton = styled.button<{ $showLabel?: boolean }>`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: ${({ $showLabel }) => ($showLabel ? "flex-start" : "center")};
  cursor: pointer;
  padding: ${({ $showLabel, theme }) => ($showLabel ? `${theme.spacing.sm} 0.75rem` : "0.5rem")};
  border-radius: ${({ theme }) => theme.borderRadius.md};
  color: ${({ theme }) => theme.colors.text};
  background: transparent;
  border: none;
  font-family: inherit;
  font-size: inherit;
  transition: all 0.2s ease-in-out;

  &:hover {
    color: ${({ theme }) => theme.colors.primary};
    background-color: ${({ theme }) => theme.colors.surface};
  }

  svg {
    width: 1.1rem;
    height: 1.1rem;
  }
`;

export const OnboardingTooltip = styled.div`
  position: absolute;
  top: 130%;
  right: 0;
  background-color: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.primaryForeground};
  padding: 0.5rem 1rem;
  border-radius: ${({ theme }) => theme.borderRadius.md};
  font-size: 0.85rem;
  font-weight: 600;
  white-space: nowrap;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  animation: float 2s infinite ease-in-out;
  pointer-events: none;
  z-index: 100;

  &::before {
    content: "";
    position: absolute;
    bottom: 100%;
    right: 10px;
    border: 6px solid transparent;
    border-bottom-color: ${({ theme }) => theme.colors.primary};
  }

  @keyframes float {
    0%,
    100% {
      transform: translateY(0);
    }
    50% {
      transform: translateY(-5px);
    }
  }
`;

export const ViewContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const TicketCard = styled.button`
  display: block;
  width: 100%;
  padding: ${({ theme }) => theme.spacing.md};
  border: 0.0625rem solid ${({ theme }) => theme.colors.border};
  border-radius: ${({ theme }) => theme.borderRadius.md};
  background: ${({ theme }) => theme.colors.surface};
  margin-bottom: ${({ theme }) => theme.spacing.sm};
  color: inherit;
  font: inherit;
  text-align: left;
  cursor: pointer;
  transition:
    border-color 0.2s ease,
    box-shadow 0.2s ease;

  &:hover {
    border-color: ${({ theme }) => theme.colors.primary};
    box-shadow: 0 0.25rem 0.5rem ${({ theme }) => `${theme.colors.text}0d`};
  }
`;

export const TicketHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: ${({ theme }) => theme.spacing.sm};
`;

export const TicketTitle = styled.h4`
  margin: 0;
  font-size: ${({ theme }) => theme.typography.sizes.md};
  color: ${({ theme }) => theme.colors.text};
`;

export const TicketDate = styled.span`
  font-size: ${({ theme }) => theme.typography.sizes.xs};
  color: ${({ theme }) => theme.colors.textMuted};
`;

export const ViewTicketLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem; /* ЦЕ ЗАМІНИТЬ marginLeft */
  margin-top: ${({ theme }) => theme.spacing.sm};
  color: ${({ theme }) => theme.colors.primary};
  font-size: ${({ theme }) => theme.typography.sizes.xs};
  font-weight: 600;
`;

export const StyledTextarea = styled.textarea<{ $hasError?: boolean }>`
  width: 100%;
  padding: ${({ theme }) => theme.spacing.sm} ${({ theme }) => theme.spacing.md};
  font-size: ${({ theme }) => theme.typography.sizes.md};
  color: ${({ theme }) => theme.colors.text};
  background-color: ${({ theme }) => theme.colors.surface};
  border: 0.0625rem solid
    ${({ theme, $hasError }) => ($hasError ? theme.colors.danger : theme.colors.border)};
  border-radius: ${({ theme }) => theme.borderRadius.md};
  outline: none;
  min-height: 8rem;
  resize: vertical;
  font-family: inherit;
  transition: all 0.2s ease;

  &:focus {
    border-color: ${({ theme }) => theme.colors.primary};
    box-shadow: 0 0 0 0.1875rem ${({ theme }) => `${theme.colors.primary}1a`};
  }
  @media (max-width: 768px) {
    font-size: 1rem;
  }
`;

export const FormGap = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.md};
  margin-bottom: ${({ theme }) => theme.spacing.lg};
`;

export const ActionFooter = styled.div`
  margin-top: auto;
  padding-top: ${({ theme }) => theme.spacing.md};
`;

export const ActionFooterRow = styled(ActionFooter)`
  display: flex;
  gap: ${({ theme }) => theme.spacing.sm};
`;

export const SupportForm = styled.form`
  display: flex;
  height: 100%;
  flex-direction: column;
`;

export const EmptyTickets = styled.div`
  padding: ${({ theme }) => theme.spacing.xl} 0;
  color: ${({ theme }) => theme.colors.textMuted};
  text-align: center;
`;

export const FieldLabel = styled.label`
  display: block;
  margin-bottom: ${({ theme }) => theme.spacing.sm};
  color: ${({ theme }) => theme.colors.text};
  font-size: ${({ theme }) => theme.typography.sizes.sm};
  font-weight: 500;
`;

export const FieldError = styled.span`
  color: ${({ theme }) => theme.colors.danger};
  font-size: ${({ theme }) => theme.typography.sizes.xs};
`;

export const UnreadBadge = styled.div`
  position: absolute;
  top: -4px;
  right: -4px;
  background-color: ${({ theme }) => theme.colors.danger};
  color: white;
  font-size: 0.65rem;
  font-weight: bold;
  height: 14px;
  min-width: 14px;
  padding: 0 4px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0 0 2px ${({ theme }) => theme.colors.background};
`;

export const FaqContainer = styled.div`
  background: ${({ theme }) => theme.colors.background};
  border-radius: ${({ theme }) => theme.borderRadius.md};
  padding: ${({ theme }) => theme.spacing.lg};
  margin-top: ${({ theme }) => theme.spacing.xl};
  border: 0.0625rem dashed ${({ theme }) => theme.colors.border};
`;

export const FaqTitle = styled.h4`
  margin: 0 0 ${({ theme }) => theme.spacing.md} 0;
  font-size: ${({ theme }) => theme.typography.sizes.xs};
  color: ${({ theme }) => theme.colors.textMuted};
  text-transform: uppercase;
  letter-spacing: 0.05em;
  font-weight: 700;
`;

export const FaqList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.sm};
`;

export const FaqLink = styled(Link)`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.sm};
  color: ${({ theme }) => theme.colors.text};
  text-decoration: none;
  font-size: ${({ theme }) => theme.typography.sizes.sm};
  font-weight: 500;
  transition: color 0.2s ease;

  &:hover {
    color: ${({ theme }) => theme.colors.primary};
  }

  svg {
    color: ${({ theme }) => theme.colors.primary};
    width: 1rem;
    height: 1rem;
  }
`;

// --- СТИЛІ ДЛЯ ВІКНА ЧАТУ ---

export const ChatContainer = styled.div`
  display: flex;
  flex-direction: column;
  /* Динамічна висота мінус приблизна висота хедера модалки/дровера */
  height: calc(100dvh - 8rem);
  max-height: 100%;
  overflow: hidden;
`;

export const MessageList = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: ${({ theme }) => theme.spacing.md} 0;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.md};

  /* Плавний скрол на iOS */
  -webkit-overflow-scrolling: touch;
`;

export const MessageWrapper = styled.div<{ isMine: boolean }>`
  display: flex;
  justify-content: ${({ isMine }) => (isMine ? "flex-end" : "flex-start")};
`;

export const MessageBubble = styled.div<{ isMine: boolean }>`
  /* На мобільному 85% ширини, на десктопі 70% */
  max-width: 85%;
  padding: ${({ theme }) => theme.spacing.sm} ${({ theme }) => theme.spacing.md};
  border-radius: ${({ theme }) => theme.borderRadius.lg};

  background-color: ${({ isMine, theme }) =>
    isMine ? theme.colors.primary : theme.colors.surface};
  color: ${({ isMine, theme }) =>
    isMine ? theme.colors.primaryForeground : theme.colors.text};
  border: 0.0625rem solid
    ${({ isMine, theme }) =>
      isMine ? theme.colors.primary : theme.colors.border};

  /* Робимо хвостики як у Telegram/iMessage */
  border-bottom-right-radius: ${({ isMine, theme }) =>
    isMine ? "0" : theme.borderRadius.lg};
  border-bottom-left-radius: ${({ isMine, theme }) =>
    isMine ? theme.borderRadius.lg : "0"};

  @media (min-width: 768px) {
    max-width: 70%;
  }
`;

export const MessageTime = styled.div<{ isMine: boolean }>`
  font-size: ${({ theme }) => theme.typography.sizes.xs};
  color: ${({ isMine, theme }) =>
    isMine ? theme.colors.primaryForeground : theme.colors.textMuted};
  opacity: 0.8;
  margin-top: 0.25rem;
  text-align: right;
`;

export const InputContainer = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.sm};
  padding-top: ${({ theme }) => theme.spacing.md};
  border-top: 0.0625rem solid ${({ theme }) => theme.colors.border};
  background: ${({ theme }) => theme.colors.background};
  position: sticky;
  bottom: 0;
`;

export const ChatInputArea = styled(StyledTextarea)`
  min-height: 3rem;
  height: 3rem;
  margin: 0;
  resize: none;
`;

// --- СТИЛІ ДЛЯ АДМІН ПАНЕЛІ (ТАБЛИЦЯ ТІКЕТІВ) ---

export const TableScrollWrapper = styled.div`
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  border: 0.0625rem solid ${({ theme }) => theme.colors.border};
  border-radius: ${({ theme }) => theme.borderRadius.md};

  table {
    min-width: 45rem; /* ~720px - не дає колонкам злипатись на мобілці */
    width: 100%;
  }
`;

export const TextareaFooter = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 0.25rem;
`;

export const CharCounter = styled.div<{ $isNearLimit?: boolean }>`
  font-size: 0.75rem;
  white-space: nowrap;
  margin-left: 1rem;
  color: ${({ theme, $isNearLimit }) =>
    $isNearLimit ? theme.colors.danger : theme.colors.textMuted};
`;
